import List from "./List";
import { Promotions } from "layouts/ecommerce/Promotions";

export const CashbackPromotions = {
  List,
  path: "/ecommerce/cashback",
  Permissions: {
    list: Promotions.Permissions.list,
  },
};
